import styled, { css } from 'styled-components';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const CardStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ofhy6d-0"
})(["width:100%;display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;border:", ";background:", ";box-shadow:", ";border-radius:", ";> *:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}> *:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}ul,ol{color:inherit;}"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.surface.container.default, ({
  theme
}) => theme.elevation.shadow.card, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large);
CardStyled.displayName = 'CardStyled';
const CardBodyStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ofhy6d-1"
})(["", " flex:1 1 auto;", " ", ""], ({
  visible
}) => visible === false ? 'display:  none;' : '', paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));
CardBodyStyled.displayName = 'CardBodyStyled';

export { CardStyled as C, CardBodyStyled as a };
//# sourceMappingURL=Card.styles-CUt4jM-_.js.map
